<div class="row">
    <div class="col-12 form-group" *ngFor="let item of list; index as index">
        <div class="d-flex justify-content-end">
            <!-- firstOperator -->
            <div class="col-4 no-padding-right first-fee" *ngIf="index > 0">
                <label>{{title1}}</label>
                <div class="d-flex">
                    <select class="form-control" name="" disabled [(ngModel)]="item.beginOperatorCode">
                        <option *ngFor="let operator of beginOperators" [value]="operator.code">
                            <label style="font-weight:600">
                                {{operator.code}}
                            </label>
                        </option>
                    </select>
                    <div class="input-group">
                        <input-number [isDecimal]="true" [(amount)]="item.beginValue" (result)="changeBeginValue(index)">
                        </input-number>
                    </div>
                </div>
            </div>
            <div class="col-4 no-padding-right second-fee" *ngIf="index !== list.length - 1 || list.length === 1">
                <div class="row">
                    <div class="col-12">
                        <label>{{title2}}</label>
                    </div>
                    <div class="col-12">
                        <!-- second Operator -->
                        <div class="d-flex test">
                            <select class="select-input form-control" [(ngModel)]="item.endOperatorCode"
                                (ngModelChange)="changeOperator(index)">
                                <option *ngFor="let operator of endOperators" [value]="operator.code">
                                    <label style="font-weight:600">
                                        {{operator.code}}
                                    </label>
                                </option>
                            </select>
                            <!-- end Volume -->
                            <input-number [isDecimal]="true" [(amount)]="item.endValue" (result)="changeEndValue(index)">
                            </input-number>
                        </div>
                    </div>

                    <!-- Error -->
                    <div class="col-12">
                        <div class="d-flex flex-column">
                            <span class="error-text" *ngIf="isValidated && item.keyValue && !item.endValue">
                                Vui lòng nhập giá trị
                            </span>
                            <span class="error-text"
                                *ngIf="isValidated && item.endValue >= 0  &&  item.endValue <= item.beginValue">
                                Giá trị nhỏ hơn giá trị trước
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Lasted Value - FEE -->
            <div class="col-4 percent-fee">
                <div class="row">
                    <div class="col-12">
                        <label>{{titleValue}}</label>
                    </div>
                    <div class="col-6">
                        <div class="input-group d-flex flex-row">
                            <input-number [isDecimal]="true" (result)="changeFee()" [(amount)]="item.keyValue"
                                [unit]="unitValue">
                            </input-number>
                        </div>
                        <span class="error-text" *ngIf="isValidated && !item.keyValue">
                            Vui lòng nhập giá trị
                        </span>
                    </div>
                    <div class="col-3">
                        <div class="remove-fee" *ngIf="!isViewed && list.length > 2">
                            <button class="btn btn__cancel" (click)="removeValueRange(index)" [hidden]="index === 0">
                                <img src="./assets/images/icons/minus.svg" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="col-3" *ngIf="index === list.length - 1">
                        <div class="remove-fee" *ngIf="!isViewed">
                            <button class="btn btn__green" (click)="addValueRange()">
                                <img src="./assets/images/icons/plus.svg" alt="">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>